import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useCourseContext } from '@ts-core/context/course';

import CoursesList from '../../components/CoursesList';
import { useCourses } from '../../hooks';

const CoursesPage = () => {
  const { courses, loading, error } = useCourses();
  const history = useHistory();
  const { setCourse } = useCourseContext();

  useEffect(() => {
    setCourse();
  }, [setCourse]);

  const onSelectCourse = useCallback(
    (course) => {
      history.push(`${course._id}/dashboard`);
    },
    [history]
  );

  return <CoursesList courses={courses} loading={loading} error={error} onSelectCourse={onSelectCourse} />;
};

export default CoursesPage;
